package com.evoapps.evoshift.ui.billing

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Close
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.ui.adaptive.ContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.WideContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.viewmodels.PlanChoiceViewModel
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.close
import evoshift.composeapp.generated.resources.paywall_not_now
import org.jetbrains.compose.resources.stringResource

/**
 * The paywall (SH-38), opened by the owner from a plan limit, the subscription screen or the
 * dashboard: EVoShift's own design on RevenueCat's offering, on every platform (RevenueCat's
 * paywall UI is not used, SH-79). Leaves with [onClose], or [onPurchased] once Pro.
 */
@Composable
fun PaywallScreen(
    viewModel: PlanChoiceViewModel,
    onClose: () -> Unit,
    onPurchased: () -> Unit
) {
    val state by viewModel.state.collectAsState()

    LaunchedEffect(state.purchased) { if (state.purchased) onPurchased() }

    com.evoapps.evoshift.widgets.GradientBox(Modifier.fillMaxSize()) {
        val wide = LocalWindowWidthClass.current.isExpanded
        Column(
            modifier = Modifier
                .fillMaxSize()
                .windowInsetsPadding(WindowInsets.safeDrawing)
                .verticalScroll(rememberScrollState())
                .contentWidth(if (wide) WideContentMaxWidth else ContentMaxWidth)
                .padding(horizontal = 24.dp, vertical = 56.dp)
        ) {
            PlanChoiceContent(
                state = state,
                onSelect = viewModel::select,
                onSelectSeats = viewModel::selectSeats,
                onSubscribe = viewModel::subscribe,
                onRestore = viewModel::restore,
                onRetry = viewModel::loadOffers,
                secondaryAction = PlanSecondaryAction(stringResource(Res.string.paywall_not_now), onClose),
                modifier = Modifier.fillMaxWidth(),
                onToggleOtherPlans = viewModel::toggleOtherPlans
            )
        }
        IconButtonWithTooltip(
            onClick = onClose,
            modifier = Modifier.align(Alignment.TopEnd).windowInsetsPadding(WindowInsets.safeDrawing).padding(8.dp),
            tooltip = stringResource(Res.string.close)
        ) {
            Icon(Icons.Default.Close, contentDescription = stringResource(Res.string.close), tint = Color.White)
        }
    }
}
